/**
 * FikoCivata Dialog — Metrik Cıvata/Diş Standardı + Sıkma Torku UI
 * Diş tablosu (adım/tap matkap/geçme deliği) + seçili ölçü için tork.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DIS_TABLOSU, CIVATA_SINIF, torkHesapla, TorkSonuc } from './FikoCivata';

@Component({
  selector: 'fikoyt-civata',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="cv">
    <div class="cv-th"><span>Ölçü</span><span>Adım</span><span>Tap Ø</span><span>Geçme Ø</span></div>
    <div class="cv-tablo">
      @for (d of tablo; track d.ad) {
        <div class="cv-r" [class.sec]="secIdx===$index" (click)="sec($index)">
          <span class="cv-ad">{{ d.ad }}</span>
          <span>{{ d.adim }}</span>
          <span class="cv-tap">{{ d.tapDrill }}</span>
          <span>{{ d.gecmeDelik }}</span>
        </div>
      }
    </div>

    <div class="cv-tork-baslik">Sıkma Torku — {{ tablo[secIdx].ad }}</div>
    <div class="cv-tork-in">
      <div class="cv-in"><label>Sınıf</label>
        <select [(ngModel)]="sinif" (ngModelChange)="hesapla()">
          @for (s of siniflar; track s) { <option [ngValue]="s">{{ s }}</option> }
        </select>
      </div>
      <div class="cv-in"><label>K faktör</label><input type="number" [(ngModel)]="kFaktor" (ngModelChange)="hesapla()" min="0.05" step="0.01"></div>
      <div class="cv-in"><label>% ön yük</label><input type="number" [(ngModel)]="yuzde" (ngModelChange)="hesapla()" min="10" max="90"></div>
    </div>
    @if (sonuc) {
      <div class="cv-sonuc">
        <div class="cv-sr"><span>Ön yük (F)</span><b>{{ f(sonuc.onYukN/1000,2) }} kN</b></div>
        <div class="cv-sr vurgu"><span>Sıkma torku</span><b>{{ f(sonuc.torkNm,1) }} N·m</b></div>
      </div>
      <div class="cv-not">💡 K=0.2 yağsız çelik. Yağlı/kaplama K düşer (tork azalır). %70 ön yük standart.</div>
    }
  </div>
  `,
  styles: [`
    .cv { padding:10px; min-width:290px; max-width:330px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .cv-th, .cv-r { display:grid; grid-template-columns:1fr 1fr 1fr 1fr; gap:4px; padding:4px 7px; align-items:center; }
    .cv-th { color:#7fc6dd; font-size:9px; }
    .cv-tablo { max-height:200px; overflow:auto; border:1px solid rgba(0,200,220,.2); border-radius:5px; }
    .cv-r { border-top:1px solid rgba(0,200,220,.1); cursor:pointer; }
    .cv-r:hover { background:rgba(0,120,150,.25); }
    .cv-r.sec { background:rgba(0,200,120,.18); }
    .cv-ad { font-weight:600; } .cv-tap { color:#ffd76a; }
    .cv-tork-baslik { color:#5fd9f5; font-weight:600; margin:8px 0 4px; font-size:10px; }
    .cv-tork-in { display:grid; grid-template-columns:1fr 1fr 1fr; gap:5px; }
    .cv-in { display:flex; flex-direction:column; gap:2px; }
    .cv-in label { font-size:9px; color:#5fd9f5; }
    .cv-in input, .cv-in select { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; min-width:0; }
    .cv-sonuc { margin-top:8px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .cv-sr { display:flex; justify-content:space-between; padding:3px 0; } .cv-sr span { color:#9fe8f7; }
    .cv-sr.vurgu { background:rgba(0,200,120,.16); margin:3px -8px -2px; padding:6px 8px; } .cv-sr.vurgu b { color:#7dffc0; font-size:14px; }
    .cv-not { margin-top:8px; font-size:9px; color:#9fe8f7; line-height:1.4; }
  `]
})
export class FikoCivataComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  tablo = DIS_TABLOSU;
  siniflar = Object.keys(CIVATA_SINIF);
  secIdx = 3;   // M6
  sinif = '8.8'; kFaktor = 0.2; yuzde = 70;
  sonuc: TorkSonuc | null = null;

  constructor(private cd: ChangeDetectorRef) { this.sonuc = this.hesaplaInt(); }

  private hesaplaInt(): TorkSonuc { return torkHesapla(this.tablo[this.secIdx], this.sinif, this.kFaktor, this.yuzde); }
  hesapla(): void { this.sonuc = this.hesaplaInt(); this.cd.detectChanges(); }
  sec(i: number): void { this.secIdx = i; this.hesapla(); }

  f(v: number, d = 1): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
